import { useCallback } from 'react';
import { useDynamicModal } from 'components/DynamicModalProvider/useDynamicModal';
import {
  DataDeletionBulkActionMenu,
  DataDeletionBulkActionMenuProps,
} from './DataDeletionBulkActionMenu';

export const useDataDeletionBulkActionMenu = () => {
  const { openModal } = useDynamicModal();

  const openApproveMenu = useCallback(
    (args: Omit<DataDeletionBulkActionMenuProps, 'onClose' | 'mode'>) => {
      openModal({
        modal: ({ toggle }) => (
          <DataDeletionBulkActionMenu {...args} mode="approve" onClose={toggle} />
        ),
      });
    },
    [openModal],
  );

  const openUnapproveMenu = useCallback(
    (args: Omit<DataDeletionBulkActionMenuProps, 'onClose' | 'mode'>) => {
      openModal({
        modal: ({ toggle }) => (
          <DataDeletionBulkActionMenu {...args} mode="unapprove" onClose={toggle} />
        ),
      });
    },
    [openModal],
  );

  return {
    openApproveMenu,
    openUnapproveMenu,
  };
};
